import { render, staticRenderFns } from "./SeckillSessionList.vue?vue&type=template&id=66fa29f4&scoped=true"
import script from "./SeckillSessionList.vue?vue&type=script&lang=js"
export * from "./SeckillSessionList.vue?vue&type=script&lang=js"
import style0 from "./SeckillSessionList.vue?vue&type=style&index=0&id=66fa29f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa29f4",
  null
  
)

export default component.exports